import { Component, Fragment } from 'react';
import styled from 'styled-components';

import { FactSubHeading, HorizontalRuler } from '~/components/Elements';
import { colors, spacing } from '~/utils/css-mixins';
import media from '~/utils/media';

import { loadStart } from '../Start/actions';
import RenderStarts from './RenderStarts';
import { groupStarts, searchFilter } from './utils';

const Search = styled.input`
  width: 100%;
  border: solid 1px ${colors.border};
  margin: ${spacing.siteGutter}px 0;
  padding: ${spacing.siteGutter}px;
  font-size: 14px;
  border-radius: 2px;

  ${media.max('xs')`
    &:focus {
      font-size: 16px;
    }
  `}
`;

class RenderAllStarts extends Component {
  static async getInitialProps({ store }) {
    store.dispatch(loadStart('tillstart'));
  }

  constructor(props) {
    super(props);
    this.state = {
      query: '',
    };
  }

  handleQueryChange = newQuery => {
    this.setState({
      query: newQuery.target.value,
    });
  };

  render() {
    const { allStarts } = this.props;
    const filteredSearch = searchFilter(allStarts, this.state.query);
    const groupedStarts = groupStarts(filteredSearch);

    return (
      <Fragment>
        <Search placeholder="Hästens namn" onChange={this.handleQueryChange} />

        {Object.keys(groupedStarts).map(category => (
          <div key={category}>
            <FactSubHeading key={category}>{category}</FactSubHeading>

            <HorizontalRuler />

            <RenderStarts starts={groupedStarts[category]} />
          </div>
        ))}
      </Fragment>
    );
  }
}
export default RenderAllStarts;
